var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalEarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9992 0.75C15.6909 0.75 12.9992 3.44165 12.9992 6.75C12.9992 7.5465 13.1625 8.30395 13.4455 9H0.949219C0.535019 9 0.199219 9.3358 0.199219 9.75V23.25C0.199219 23.6642 0.535019 24 0.949219 24H21.9992C22.4134 24 22.7492 23.6642 22.7492 23.25V11.3955C24.1101 10.2947 24.9992 8.63255 24.9992 6.75C24.9992 3.44165 22.3076 0.75 18.9992 0.75Z",
    fill: "url(#paint0_linear_2464_4317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19.5H8.5C8.08545 19.5 7.75 19.8355 7.75 20.25C7.75 20.6646 8.08545 21 8.5 21H10C10.4145 21 10.75 20.6646 10.75 20.25C10.75 19.8355 10.4145 19.5 10 19.5ZM10 12H4C3.58545 12 3.25 12.3355 3.25 12.75V14.25C3.25 14.6645 3.58545 15 4 15H10C10.4145 15 10.75 14.6645 10.75 14.25V12.75C10.75 12.3355 10.4145 12 10 12ZM5.5 19.5H4C3.58545 19.5 3.25 19.8355 3.25 20.25C3.25 20.6646 3.58545 21 4 21H5.5C5.91455 21 6.25 20.6646 6.25 20.25C6.25 19.8355 5.91455 19.5 5.5 19.5ZM14.5 19.5H13C12.5854 19.5 12.25 19.8355 12.25 20.25C12.25 20.6646 12.5854 21 13 21H14.5C14.9145 21 15.25 20.6646 15.25 20.25C15.25 19.8355 14.9145 19.5 14.5 19.5ZM19 19.5H17.5C17.0854 19.5 16.75 19.8355 16.75 20.25C16.75 20.6646 17.0854 21 17.5 21H19C19.4145 21 19.75 20.6646 19.75 20.25C19.75 19.8355 19.4145 19.5 19 19.5ZM19 0C15.2778 0 12.25 3.02785 12.25 6.75C12.25 10.4721 15.2778 13.5 19 13.5C22.7221 13.5 25.8 10.4721 25.8 6.75C25.8 3.02785 22.7221 0 19 0ZM19.75 10.3618V11.25C19.75 11.6645 19.4145 12 19 12C18.5854 12 18.25 11.6645 18.25 11.25V10.3545C17.8389 10.2073 17.4671 9.9561 17.2004 9.6006C16.9521 9.2688 17.0188 8.7986 17.3498 8.5503C17.6831 8.30345 18.1518 8.3701 18.4001 8.6997C18.5429 8.89085 18.7619 9 19 9C19.4138 9 19.75 8.6638 19.75 8.25C19.75 7.8362 19.4138 7.5 19 7.5C17.7593 7.5 16.75 6.4907 16.75 5.25C16.75 4.2735 17.3789 3.4488 18.25 3.13815V2.25C18.25 1.83545 18.5854 1.5 19 1.5C19.4145 1.5 19.75 1.83545 19.75 2.25V3.14555C20.161 3.29275 20.5328 3.5439 20.7995 3.8994C21.0478 4.2312 20.9812 4.7014 20.6501 4.9497C20.3191 5.198 19.8496 5.1328 19.5998 4.8003C19.2072 4.2759 18.2492 4.5974 18.25 5.25C18.25 5.6638 18.5862 6 19 6C20.2407 6 21.25 7.0093 21.25 8.25C21.25 9.2265 20.6211 10.0512 19.75 10.3618Z",
    fill: "url(#paint1_linear_2464_4317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2464_4317",
    x1: 12.5992,
    y1: 24,
    x2: 12.5992,
    y2: 0.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2464_4317",
    x1: 14.525,
    y1: 21,
    x2: 14.525,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalEarning);
export default __webpack_public_path__ + "static/media/total-earning.b2d40f53a5f36a7ea055e456a7401ee9.svg";
export { ForwardRef as ReactComponent };